module.exports = __webpack_public_path__ + "img/icon_interface.961fe88c.svg";